var RevistaSearch = RevistaSearch || {};

// ============================================================================
// UTILITÁRIOS - VALIDAÇÃO
// ============================================================================

RevistaSearch.Validators = {
  isValidDateFormat(dateString) {
    return /^\d{4}-\d{2}-\d{2}$/.test(dateString);
  },

  isValidDateRange(from, to) {
    if (!from || !to) return true;
    return from <= to;
  },

  validateDates(dateFrom, dateTo) {
    if (dateFrom && !this.isValidDateFormat(dateFrom))
      return 'Data inicial inválida. Use o formato yyyy-MM-dd.';
    if (dateTo && !this.isValidDateFormat(dateTo))
      return 'Data final inválida. Use o formato yyyy-MM-dd.';
    if (!this.isValidDateRange(dateFrom, dateTo))
      return 'A data inicial deve ser anterior à data final.';
    return null;
  },
};

// ============================================================================
// UTILITÁRIOS - FORMATAÇÃO
// ============================================================================

RevistaSearch.Formatters = {
  escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  },

  sanitizeString(str) {
    return str ? String(str).trim() : '';
  },

  sanitizeDate(value) {
    const trimmed = value ? String(value).trim() : '';
    return trimmed || null;
  },

  clearElement(element) {
    if (!element) return;
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  },

};

// ============================================================================
// UTILITÁRIOS - MAPEAMENTO
// ============================================================================

RevistaSearch.Mappers = {
  formTypeToApi(formType) {
    return Object.values(RevistaSearch.CONTENT_TYPES).find(v => v.form === formType)?.api ?? null;
  },

  apiTypeToForm(apiType) {
    return Object.values(RevistaSearch.CONTENT_TYPES).find(v => v.api === apiType)?.form ?? apiType.toLowerCase();
  },

  matchToSearchType(matchValue) {
    const map = {
      any: RevistaSearch.CONFIG.SEARCH.TYPE.ANY,
      phrase: RevistaSearch.CONFIG.SEARCH.TYPE.PHRASE,
      all: RevistaSearch.CONFIG.SEARCH.TYPE.ALL,
    };
    return map[matchValue] || RevistaSearch.CONFIG.SEARCH.TYPE.ALL;
  },

  sortToOrder(sortValue) {
    if (sortValue === 'date-desc' || sortValue === 'date-asc') {
      return RevistaSearch.CONFIG.SEARCH.ORDER.MOST_RECENT;
    }
    return RevistaSearch.CONFIG.SEARCH.ORDER.MOST_RELEVANT;
  },
};
